module.exports = __webpack_public_path__ + "static/video2-943c8559455cfb803f77a10bda81f2d5.png";